// extracted by mini-css-extract-plugin
module.exports = {"badges":"form-label_badges__MbOCO","label":"form-label_label__YGx0g token-typography-body-200 mds-typography-font-weight-semibold"};